/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ArchiveTrackingPixelsBody} from './schemas/archive-tracking-pixels-body';

import type {CreateTrackingPixel200} from './schemas/create-tracking-pixel200';

import type {CrupdateTrackingPixelBody} from './schemas/crupdate-tracking-pixel-body';

import type {DeleteTrackingPixelsParams} from './schemas/delete-tracking-pixels-params';

import type {ListTrackingPixelsParams} from './schemas/list-tracking-pixels-params';

import type {ListTrackingPixels200} from './schemas/list-tracking-pixels200';

import type {RetrieveTrackingPixel200} from './schemas/retrieve-tracking-pixel200';

import type {UnarchiveTrackingPixelsBody} from './schemas/unarchive-tracking-pixels-body';

import type {UpdateTrackingPixel200} from './schemas/update-tracking-pixel200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve a tracking pixel
 */
export const retrieveTrackingPixel = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveTrackingPixel200>>,
) => {
  return orvalApiFetch<RetrieveTrackingPixel200>(
    {url: `/tp/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a tracking pixel
 */
export const updateTrackingPixel = (
  id: number,
  crupdateTrackingPixelBody: CrupdateTrackingPixelBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateTrackingPixel200>>,
) => {
  return orvalApiFetch<UpdateTrackingPixel200>(
    {
      url: `/tp/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateTrackingPixelBody,
    },
    options,
  );
};
/**
 * @summary List all tracking pixels
 */
export const listTrackingPixels = (
  params?: ListTrackingPixelsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListTrackingPixels200>>,
) => {
  return orvalApiFetch<ListTrackingPixels200>(
    {url: `/tp`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a tracking pixel
 */
export const createTrackingPixel = (
  crupdateTrackingPixelBody: CrupdateTrackingPixelBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateTrackingPixel200>>,
) => {
  return orvalApiFetch<CreateTrackingPixel200>(
    {
      url: `/tp`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateTrackingPixelBody,
    },
    options,
  );
};
/**
 * @summary Delete tracking pixels
 */
export const deleteTrackingPixels = (
  params: DeleteTrackingPixelsParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/tp/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Archive tracking pixels
 */
export const archiveTrackingPixels = (
  archiveTrackingPixelsBody: ArchiveTrackingPixelsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/tp/bulk/archive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: archiveTrackingPixelsBody,
    },
    options,
  );
};
/**
 * @summary Unarchive tracking pixels
 */
export const unarchiveTrackingPixels = (
  unarchiveTrackingPixelsBody: UnarchiveTrackingPixelsBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/tp/bulk/unarchive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unarchiveTrackingPixelsBody,
    },
    options,
  );
};
export type RetrieveTrackingPixelResult = NonNullable<
  Awaited<ReturnType<typeof retrieveTrackingPixel>>
>;
export type UpdateTrackingPixelResult = NonNullable<
  Awaited<ReturnType<typeof updateTrackingPixel>>
>;
export type ListTrackingPixelsResult = NonNullable<
  Awaited<ReturnType<typeof listTrackingPixels>>
>;
export type CreateTrackingPixelResult = NonNullable<
  Awaited<ReturnType<typeof createTrackingPixel>>
>;
export type DeleteTrackingPixelsResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrackingPixels>>
>;
export type ArchiveTrackingPixelsResult = NonNullable<
  Awaited<ReturnType<typeof archiveTrackingPixels>>
>;
export type UnarchiveTrackingPixelsResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveTrackingPixels>>
>;
